﻿export enum AffiliationType {
    Undefined = 0,
    Client = 1,
    Customer = 2,
    VRLink = 3
}